import { render, staticRenderFns } from "./spaceConfig.vue?vue&type=template&id=020ed5aa&scoped=true&"
import script from "./spaceConfig.vue?vue&type=script&lang=ts&"
export * from "./spaceConfig.vue?vue&type=script&lang=ts&"
import style0 from "./spaceConfig.vue?vue&type=style&index=0&id=020ed5aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ed5aa",
  null
  
)

export default component.exports